import { createListenerMiddleware } from '@reduxjs/toolkit';
import { loadDeviceZ3kConfig } from 'z3k-settings/components/view-config/redux/actions';
export const listenerMiddlewareUpdateZ3KConfigHistory = createListenerMiddleware();
listenerMiddlewareUpdateZ3KConfigHistory.startListening({
    type: 'SAVE_Z3K_SETTINGS__OK',
    effect: (action, listenerApi) => {
        const state = listenerApi.getState();
        if (state.z3k_device_config_history.config_history.length !== 0) {
            listenerApi.dispatch(loadDeviceZ3kConfig(action.device_id));
        }
    },
});
